export default function TodayLeaderboard({ entries, text }) {
    return (
        <section className="user-attempts today-leaderboard">
            <h2>{text.todayLeaderboardTitle}</h2>
            {entries.length === 0 ? (
                <p className="quiz-empty-state">{text.todayLeaderboardEmpty}</p>
            ) : (
                <>
                    <div className="today-leaderboard-heading" aria-hidden="true">
                        <span />
                        <span>{text.leaderboardPlayer}</span>
                        <span>{text.leaderboardQuiz}</span>
                        <span>{text.leaderboardScore}</span>
                    </div>
                    <ol className="today-leaderboard-list">
                        {entries.map((entry, index) => (
                            <li className="today-leaderboard-entry" key={entry.id}>
                                <span className="today-leaderboard-rank">#{index + 1}</span>
                                <span className="today-leaderboard-player">{entry.userName}</span>
                                <span className="today-leaderboard-quiz">{entry.quizTitle}</span>
                                <span className="today-leaderboard-score">
                                    {entry.score} / {entry.totalQuestions}
                                    {" · "}
                                    {Math.round((entry.score / entry.totalQuestions) * 100)}%
                                </span>
                            </li>
                        ))}
                    </ol>
                </>
            )}
        </section>
    );
}
